<div class="menu-main d-flex align-items-center justify-content-end">
  <div class="main-menu f-right d-none d-lg-block">
    <nav>
      <ul id="navigation">
        <li *ngFor="let m of menuService.menu; let i = index">
          {{m.sottomenu?.length}}
          <ng-container *ngIf="m.sottomenu && m.sottomenu.length > 0">

          <a href="javascript:void(0);">{{m.nome}}</a>
            <ul class="submenu">
              <li *ngFor="let sub of m.sottomenu"><a [routerLink]="sub.route">{{sub.nome}}</a></li>
            </ul>

        </ng-container>
          <a *ngIf="!m.sottomenu || m.sottomenu.length === 0" [routerLink]="m.route">{{m.nome}}</a>
        </li>
      </ul>
    </nav>
  </div>
</div>
